export default __webpack_public_path__ + "static/media/ZhtgDLNc3G.e0b0cd39.gif";